export const ocplcRegionDropDown =`query ocplcRegionDropDown($filter: OcplcRegionRequest!) {
  ocplcRegionDropDown (filter: $filter ) {
    regions {
      code
      name
    }
  }
}`;
